import script from "./Challenges.vue?vue&type=script&setup=true&lang=js"
export * from "./Challenges.vue?vue&type=script&setup=true&lang=js"

import "./Challenges.vue?vue&type=style&index=0&id=caa0c29a&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-caa0c29a"]])

export default __exports__